/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// import { useStaticQuery, graphql } from "gatsby";
import { MainLayout, Sticky } from "wmk-lib";
import styled from "styled-components";

import Footer from "./Footer/Footer";
import Header from "./MainMenu/MainMenu";
import BrowserCompatibility from "./BrowserCompatibility";

const Global = {};
Global.Wrapper = styled.div`
  @import url("https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;600&display=swap");
  font-family: "Nunito Sans", sans-serif;
  font-weight: 300;
  .wmk-layout-sticky-header {
    transition: all 0.3s ease;
    background: white;
    .logo-wrap {
      max-width: 300px;
      padding: 2vh 0;
      tranistion: all 0.3s ease;
    }
    &.stuck {
      transition: all 0.3s ease;
      .top-bar {
        display: none;
      }
      .logo-wrap {
        max-width: 160px;
        padding: 1vh 0;
        transition: all 0.3s ease;
      }
    }
  }
`;

Global.Fallback = styled.div`
.main-footer {
  height: 244px;
  & > .row {
    width: 100%;
    height: 200px;
    & > div {
      width: ${100/3}%;
      height: 200px;
      & > .row {
        height: 200px;
        display: block;
      }
    }
  }
}
.wmk-search-drawer {
  .results {
    & > .container > .row {
      display: block;
    }
  }
}
.menu-drawer {
  display: block;
}
.wmk-layout-main {
  .wmk-link[class*="Backlink"] {
    display: block;
    width: 100%;
    text-align: center;
  }
  div[class*="PageIntro"] {
    display: block;
  }
}
.curved {
  svg[class*="CurveAI"] {
    display: none;
  }
}
div[class*="topic__FlexibleContent"] {
  & > .container > .row {
    display: block;
  }
}
.module-texts {
  div[class*="Text__ContentWrap"] {
    display: block;
  }
}
button[class*="HoverTile"] {
  .content-div {
    display: block;
  }
}
div[class*="BlockBody__Signature"] {
  display: block;
}
`

const Layout = ({ children, pageType, slug, parentChapter }) => {
  const [winWidth, setWinWidth] = useState(0);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [topBarHeight, setTopBarHeight] = useState(0);
  useEffect(() => {
    const handleResize = () => {
      setWinWidth(window.outerWidth);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [winWidth]);

  return (
    <Global.Wrapper>
      <BrowserCompatibility Styled={Global.Fallback}>
        <MainLayout
          Header={() => (
            <Sticky trigger={topBarHeight}>
              <Header
                winWidth={winWidth}
                isSearchOpen={isSearchOpen}
                setIsSearchOpen={setIsSearchOpen}
                pageType={pageType}
                slug={slug}
                parentChapter={parentChapter}
                setTopBarHeight={setTopBarHeight}
              />
            </Sticky>
          )}
          Footer={() => <Footer winWidth={winWidth} />}
        >
          {children}
        </MainLayout>
      </BrowserCompatibility>
    </Global.Wrapper>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
